import { cn } from "@/lib/cn";

export function Eyebrow({
  children,
  className,
  tone = "default",
}: {
  children: React.ReactNode;
  className?: string;
  tone?: "default" | "accent" | "inverse";
}) {
  const tones = {
    default: "border-ink/15 text-ink-muted",
    accent: "border-accent bg-accent/15 text-ink",
    inverse: "border-white/20 text-white/80",
  } as const;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full border px-3 py-1 text-[11px] font-semibold uppercase tracking-caps",
        tones[tone],
        className,
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {children}
    </span>
  );
}
